<template>
    <div>
        <div class="top">
            <div class="topleft">
                <el-breadcrumb separator="/">
                    <el-breadcrumb-item :to="{ path: '/home' }">{{$t('home')}}</el-breadcrumb-item>
                    <el-breadcrumb-item>{{$t('ddgl')}}</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
        </div>
        <div class="cont">
            <div class="listbox">
                <div class="listright" v-loading="loading">
                    <div class="search">
                        <div class="searchleft">
                            <el-form :inline="true" :model="searchform" class="demo-form-inline" @submit.native.prevent >
                                <el-form-item :label="$t('phone')">
                                    <el-input v-model="searchform.phone" style="width: 150px;" @keyup.enter.native="onSubmit" size="small"></el-input>
                                </el-form-item>
                                <el-form-item :label="$t('mchOrderNo')">
                                    <el-input v-model="searchform.mchOrderNo" style="width: 150px;" @keyup.enter.native="onSubmit" size="small"></el-input>
                                </el-form-item>
                                <el-form-item :label="$t('skzh')">
                                    <el-input v-model="searchform.cuenta" @keyup.enter.native="onSubmit" size="small"></el-input>
                                </el-form-item>
                                <el-form-item label="App">
                                    <el-select v-model="searchform.app" @change="onAppChange" placeholder="请选择" style="width:150px">
                                        <el-option :label="$t('buxian')" :value="null"></el-option>
                                        <el-option label="Aktivaku" value="Aktivaku"></el-option>
                                        <el-option label="Sanders" value="Sanders"></el-option>
                                        <el-option label="papitupi" value="papitupi"></el-option>
                                        <el-option label="Igrow" value="Igrow"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="子产品">
                                    <el-select v-model="searchform.platform" :disabled="filteredPlatforms.length === 0" placeholder="请选择" style="width:150px">
                                        <el-option :label="$t('buxian')" :value="null"></el-option>
                                        <el-option
                                            v-for="item in filteredPlatforms"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value"
                                        />
                                    </el-select>
                                </el-form-item>
                                <el-form-item :label="$t('type')">
                                    <el-select v-model="searchform.statusValue" style="width:120px;">
                                        <el-option :label="$t('buxian')" :value="null"></el-option>
                                        <el-option :label="$t('loan4')" :value="0"></el-option>
                                        <el-option :label="$t('loan5')" :value="1"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item :label="$t('status')">
                                    <el-select size="small" v-model="searchform.status" style="width:120px;">
                                        <el-option :label="$t('buxian')" :value="null"></el-option>
                                        <el-option :label="$t('shz')" :value="1"></el-option>
                                        <el-option :label="$t('yfk')" :value="2"></el-option>
                                        <el-option :label="$t('fksb')" :value="3"></el-option>
                                        <el-option :label="$t('yhk')" :value="4"></el-option>
                                        <el-option :label="$t('ddbj')" :value="5"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item :label="$t('time')">
                                    <el-date-picker
                                    v-model="value1"
                                    type="datetimerange"
                                    size="small"
                                    @change="checkdata"
                                    range-separator="至"
                                    value-format="yyyy-MM-dd HH:mm:ss"
                                    start-placeholder="开始时间"
                                    end-placeholder="结束时间">
                                    </el-date-picker>
                                </el-form-item>
                                <el-form-item>
                                    <el-button size="small" type="primary" @click="onSubmit">{{$t('query')}}</el-button>
                                </el-form-item>
                            </el-form>
                        </div>
                    </div>
                    <el-table :data="list" 
                        :header-cell-style="{'background':'#f5f5f5','font-weight':'bold','color':'#555555','padding':'6px 0'}" style="width: 100%">
                        <el-table-column fixed prop="phone" :label="$t('phone')" width="120px"></el-table-column>
                        <el-table-column prop="orderNo" :label="$t('orderNo')" width="150px"></el-table-column>
                        <el-table-column fixed prop="mchOrderNo" :label="$t('mchOrderNo')" width="210px"></el-table-column>
                        <el-table-column prop="money" :formatter="formatInteres" :label="$t('dkje')" width="80px"></el-table-column>
                        <el-table-column prop="days" :label="$t('days')" width="80px"></el-table-column>
                        <el-table-column prop="amount" :formatter="formatInteres" :label="$t('fkje')" width="80px"></el-table-column>
                        <el-table-column prop="costo" :formatter="formatInteres" :label="$t('fwf')" width="80px"></el-table-column>
                        <el-table-column prop="interes" :formatter="formatInteres" :label="$t('lx')" width="80px"></el-table-column>
                        <el-table-column prop="cantidad" :formatter="formatInteres" :label="$t('ssje')" width="80px"></el-table-column>
                        <el-table-column prop="cuenta" :label="$t('skzh')" width="180px"></el-table-column>
                        <el-table-column prop="level" :label="$t('createTime')" width="180px">
                            <template slot-scope="scope">
                                {{scope.row.createTime|changedate}}
                            </template>
                        </el-table-column>
                        <el-table-column prop="expireTime" :label="$t('expireTime')" width="100px"></el-table-column>
                        <el-table-column prop="loanTime" :label="$t('fksj')" width="120px"></el-table-column>
                        <el-table-column prop="level" :label="$t('lastTime')" width="180px">
                            <template slot-scope="scope" v-if="scope.row.lastTime != null">
                                {{scope.row.lastTime|changedate}}
                            </template>
                        </el-table-column>
                        <el-table-column fixed prop="status" :label="$t('status')" width="120">
                            <template slot-scope="scope">
                                <el-tag v-if="scope.row.status==1" type="primary" size="mini" :title="$t('shz')">{{$t('shz')}}</el-tag>
                                <el-tag v-if="scope.row.status==2" type="info" size="mini" :title="$t('yfk')">{{$t('yfk')}}</el-tag>
                                <el-tag v-if="scope.row.status==3" type="warning" size="mini" :title="$t('fksb')">{{$t('fksb')}}</el-tag>
                                <el-tag v-if="scope.row.status==4" type="success" size="mini" :title="$t('yhk')">{{$t('yhk')}}</el-tag>
                                <el-tag v-if="scope.row.status==5" type="danger" size="mini" :title="$t('ddbj')">{{$t('ddbj')}}</el-tag>
                                <el-tag v-if="scope.row.status==6" type="danger" size="mini" :title="$t('zq')">{{$t('zq')}}</el-tag>
                                <el-tag v-if="scope.row.status==7" type="danger" size="mini" :title="$t('fqwsx')">{{$t('fqwsx')}}</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column prop="body" :label="$t('pingt')" width="120px"></el-table-column>
                        <el-table-column fixed prop="statusValue" :label="$t('status')" width="100">
                            <template slot-scope="scope">
                                <el-tag v-if="scope.row.statusValue == 0" type="info">{{$t('loan4')}}</el-tag>
                                <el-tag v-if="scope.row.statusValue == 1" type="info">{{$t('loan5')}}</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column prop="jobName" :label="$t('operator')" width="188px" fixed="right">
                            <template slot-scope="scope">
                                <el-popconfirm :title="$t('iscancelar')" v-if="scope.row.status == 2" @confirm="cancelar(scope.row)">
                                    <el-button size="small" type="warning" icon="el-icon-s-check" circle slot="reference" plain></el-button>
                                </el-popconfirm>
                                <el-tooltip style="margin-left: 10px;" v-if="scope.row.status == 2" class="item" effect="dark" :content="$t('ag7')">
                                     <el-button size="small" @click="openedit(scope.row)"  type="primary" icon="el-icon-remove" circle plain></el-button>
                                </el-tooltip>
                                <!-- <el-tooltip style="margin-left: 10px;" v-if="scope.row.status == 2 && scope.row.agingDetail == null" class="item" effect="dark" :content="$t('ag6')">
                                     <el-button size="small" @click="stages(scope.row)"  type="primary" icon="el-icon-connection" circle plain></el-button>
                                </el-tooltip>
                                <el-popconfirm style="margin-left: 10px;" :title="$t('ag9')" v-if="scope.row.status == 2 && scope.row.agingDetail == null" @confirm="agingCheck(scope.row)">
                                    <el-button size="small" type="warning" icon="el-icon-coordinate" circle slot="reference" plain></el-button>
                                </el-popconfirm> -->
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="page">
                        <app-page :total="total" :current="pageNo" :pageSize="pageSize"
                            @handleCurrentChange="currentchange" @handleSizeChange="handchange"></app-page>
                    </div>
                </div>
            </div>
        </div>
        <pop-up :title="$t('ag7')" :isshow="showadd" :haveconfirm="true" cancel-text="自定义取消" confirm-text="自定义确认" @close="getclose" @confirm="getconfirm">
            <div slot="box">
                <el-form ref="form" :inline="true" :model="form" :rules="rules" size="small">
                    <el-form-item :label="$t('ag8')" prop="money">
                        <el-input-number v-model="form.money" />
                    </el-form-item>
                </el-form>
            </div>
        </pop-up>
        <pop-up :title="$t('ag6')" :isshow="showadd1" :haveconfirm="true" @close="getclose1" @confirm="getconfirm1">
            <div slot="box">
                <el-form ref="form" :inline="true" :model="form1" :rules="rules" size="small">
                    <el-form-item :label="$t('fqcs')" prop="value">
                        <el-select  @change="options" v-model="form1.value" :placeholder="$t('qxz')">
                            <el-option v-for="item in limitList" :key="item.value"
                            :label="item.value"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-table :data="list2" 
                        :header-cell-style="{'background':'#f5f5f5','font-weight':'bold','color':'#555555','padding':'6px 0'}" style="width: 100%">
                        <el-table-column prop="count" :label="$t('fqcs')" width="50px"></el-table-column>
                        <el-table-column prop="endTime" :label="$t('ag1')"></el-table-column>
                        <el-table-column prop="day" :label="$t('ag2')"></el-table-column>
                        <el-table-column prop="money" :label="$t('ag3')"></el-table-column>
                        <el-table-column prop="accrual" :label="$t('ag4')"></el-table-column>
                        <el-table-column prop="capital" :label="$t('ag5')"></el-table-column>
                    </el-table>
                </el-form>
            </div>
        </pop-up>
    </div>
</template>
<script>
    import apiurl from "@/api/public"
    import _api from "@/api/index"
    import Treeselect from '@riophae/vue-treeselect'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import {
        LOAD_CHILDREN_OPTIONS
    } from '@riophae/vue-treeselect'
    export default {
        components: {
            Treeselect
        },
        data() {
            var rolesValid = (rule, value, callback) => {
                callback()
            }
            return {
                form: {
                    orderId: null,
                    money: null,
                },
                form1: {
                    value: null,
                },
                form2: {
                    orderId: null,
                    count: null,
                    money: null,
                    interest: null,
                    principal: null,
                },
                loading: false,
                showadd: false,
                showadd1: false,
                list: [],
                list1: [],
                list2: [],
                limitList: [],
                searchform:{
                    app:"",
                    platform:"",
                },
                total: 1,
                pageNo: 1,
                pageSize: 10,
                value1:null,
                platformOptions: [
                    { label: "GraDana", value: "GraDana", app: "Aktivaku" },
                    { label: "AwanTunai", value: "AwanTunai", app: "Aktivaku" },
                    { label: "Aktivaku", value: "Aktivaku", app: "Aktivaku" },

                    { label: "IKIModal", value: "IKIModal", app: "Sanders" },
                    { label: "Ethis", value: "Ethis", app: "Sanders" },
                    { label: "Sanders", value: "Sanders", app: "Sanders" },

                    { label: "Duha", value: "Duha", app: "papitupi" },
                    { label: "komunal", value: "komunal", app: "papitupi" },
                    { label: "papitupi", value: "papitupi", app: "papitupi" },

                    { label: "Qazwa", value: "Qazwa", app: "Igrow" },
                    { label: "Restock", value: "Restock", app: "Igrow" },
                    { label: "Igrow", value: "Igrow", app: "Igrow" },
                ],
            }
        },
        created() {
            this.user=JSON.parse(localStorage.getItem("userinfo"))
            this.value1 = this.getNowTime()
            this.getList()
        },
        computed: {
            filteredPlatforms() {
                if (!this.searchform.app) return []; // 默认空
                return this.platformOptions.filter(item => item.app === this.searchform.app);
            }
        },
        methods: {
            onAppChange() {
                this.searchform.platform = null; // 切换 app 时清空子产品
            },
            getNowTime() {
                const start = new Date(new Date().getTime() - 3600 * 1000 * 24 * 14)
                    .toISOString()
                    .replace('T', ' ')
                    .split('.')[0] //默认开始时间7天前
                const end = new Date(new Date().getTime() + 3600 * 1000 * 24 * 1)
                    .toISOString()
                    .replace('T', ' ')
                    .split('.')[0]//默认结束时间1天前
                return [start, end]
            },
            formatInteres(row, column, value) {
                // 将值转换为数字，若转换失败则返回原值
                const number = Number(value);
                return isNaN(number) ? value : number.toLocaleString('en-US');
            },
            checkdata(){
                this.getList()
            },
            cancelar(row) {
                _api.get(apiurl.cancelarOrder, {
                    orderId: row.id,
                }).then(res => {
                    this.$notify({
                        title: this.$t('success'),
                        message: this.$t('success'),
                        type: 'success'
                    });
                    this.getList()

                }).catch(err => {
                    this.$notify.error({
                        title: this.$t('error'),
                        message: err.data.message
                    });
                })
            },
            agingCheck(row) {
                _api.get(apiurl.agingCheck, {
                    orderId: row.id,
                }).then(res => {
                    this.$notify({
                        title: this.$t('success'),
                        message: this.$t('success'),
                        type: 'success'
                    });
                    this.getList()
                }).catch(err => {
                    this.$notify.error({
                        title: this.$t('error'),
                        message: err.data.message
                    });
                })
            },
            openedit(row) {
                this.showadd = true
                this.form.orderId = row.id
                this.form.money = row.cantidad
            },
            stages(row) {
                this.showadd1 = true
                this.form2.orderId = row.id
                _api.get(apiurl.agingInfo, {
                    orderId: row.id,
                    platName: row.body,
                }).then(res => {
                    this.list1 = res.data.date
                    this.limitList = res.data.limits
                }),
                this.list2 = null;
            },
            options() {
                for (var i = 0; i < this.list1.length; i++) {
                    if (this.list1[i].count == this.form1.value) {
                        this.form2.count = this.form1.value;
                        this.form2.money = this.list1[i].agingInfos[0].money;
                        this.form2.interest = this.list1[i].agingInfos[0].accrual;
                        this.form2.principal = this.list1[i].agingInfos[0].capital;
                        this.list2 = this.list1[i].agingInfos;
                    }
                }
            },
            getList() {
                this.loading = true
                _api.get(apiurl.order, {
                    page: this.pageNo,
                    size: this.pageSize,
                    cuenta: this.searchform.cuenta,
                    phone: this.searchform.phone,
                    mchOrderNo: this.searchform.mchOrderNo,
                    status: this.searchform.status,
                    nation:localStorage.getItem("nation"),
                    platform:this.searchform.platform,
                    type: this.searchform.statusValue,
                    createTime: this.value1,
                    app: this.searchform.app,
                }).then(res => {
                    this.loading = false
                    this.list = res.data.list
                    this.total = res.data.total
                })
            },
            getconfirm() {
                if(this.form.money == null || this.form.money == ""){
                    this.$message.error('金额不能不空')
                    return
                }
                _api.put(apiurl.orderMoneyTax, this.form).then(res => {
                    this.$notify.success({
                        title: this.$t('success'),
                        message: this.$t('editSuccess')
                    })
                    this.getList()
                    this.form = {
                        orderId: null,
                        money: null,
                    }
                    this.showadd = false
                }).catch(err => {
                    this.$notify.error({
                        title: this.$t('error'),
                        message: err.data.message
                    })
                })
            },
            getclose() {
                this.$refs.form.resetFields();
                this.showadd = false
            },
            getclose1() {
                this.$refs.form.resetFields();
                this.showadd1 = false
            },
            getconfirm1() {
                _api.post(apiurl.saveAgingOrder, this.form2).then(res => {
                    this.$notify.success({
                        title: this.$t('success'),
                        message: this.$t('editSuccess')
                    })
                    this.getList()
                    this.form2 = {
                        orderId: null,
                        count: null,
                        money: null,
                        interest: null,
                        principal: null,
                    }
                    this.showadd1 = false
                }).catch(err => {
                    this.$notify.error({
                        title: this.$t('error'),
                        message: err.data.message
                    })
                })
            },
            onSubmit() {
                this.pageNo = 1
                this.getList()
            },
            handchange(data) { //分页Size变化
                this.pageSize = data
                this.pageNo = 1
                this.getList()
            },
            currentchange(data) { //当前页变化
                this.pageNo = data
                this.getList()
            },
        }
    }
</script>
<style scoped>
    .lefttop {
        padding: 8px;
    }

    .listbox {
        display: flex;
    }

    .listleft {
        width: 20%;
        border: 1px solid #EBEEF5;
    }

    .listright {
        width: 100%;
        margin-left: 1%;
    }

    .listrighttop {
        padding: 0 10px;
        background: rgb(245, 245, 245);
        height: 40px;
        overflow: hidden;
        line-height: 40px;
        border-bottom: 1px solid #EBEEF5;
    }

    .listrighttop strong {
        float: left;
    }

    .listrighttop span {
        float: right;
    }

    ::v-deep .vue-treeselect__control,
    ::v-deep .vue-treeselect__placeholder,
    ::v-deep .vue-treeselect__single-value {
        height: 30px;
        line-height: 30px;
    }
</style>